import { multiFilter } from "@homebound/beam";
import { useMemo } from "react";
import { ReadyPlanStatus } from "src/generated/graphqlTypes";
import { useReadyPlanStatusFilterMetadataQuery } from "src/hooks/filters/readyPlanStatus/useReadyPlanStatusFilter.generated";

type UseReadyPlanStatusFilterOptions = {
  // DesignPackage entities are only ever Active or Archived; unlike PlanPackages they don't
  // use the Draft entity status (draft work is tracked at the version level via
  // AggregateVersionStatus). So this flag drops Draft from the filter options — it would never
  // match anything — and defaults the filter to Active.
  isDPFilter?: boolean;
  omitArchived?: boolean;
};

export function useReadyPlanStatusFilter(opts: UseReadyPlanStatusFilterOptions = {}) {
  const { isDPFilter, omitArchived } = opts;
  const { data } = useReadyPlanStatusFilterMetadataQuery({ fetchPolicy: "cache-first" });
  const rpStatusFilter = useMemo(
    () =>
      multiFilter({
        options: (data?.enumDetails.readyPlanStatus ?? [])
          .filter((s) => !isDPFilter || s.code !== ReadyPlanStatus.Draft)
          .filter((s) => !omitArchived || s.code !== ReadyPlanStatus.Archived),
        getOptionValue: (o) => o.code,
        getOptionLabel: (o) => o.name,
        // Default to Active so the filter UI matches what the list query actually returns
        defaultValue: isDPFilter ? [ReadyPlanStatus.Active] : undefined,
      }),
    // TODO: validate this eslint-disable. It was automatically ignored when the oxlint migration restored `react-hooks/exhaustive-deps` to an error.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, isDPFilter],
  );

  return { rpStatusFilter };
}
